import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { withFirebase } from '../../../views/firebase';
import { toast } from 'react-toastify';
import UsersService from '../../../services/Users.js';
import FhirService from '../../../services/MiEFhir.js';
import { CButton, CCard, CCardBody, CInputGroup, CInputGroupText, CForm, CFormCheck, CFormInput, CRow, CCol } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilUser, cilCalendar, cilCheckCircle } from '@coreui/icons';
import logo from '../../../assets/AA-01.jpg';


const VerifyEmail = ({ firebase }) => {
      const [loading, setLoading] = useState(true);
      const [verified, setVerified] = useState(false);
      const [formData, setFormData] = useState({
            name: '',
            dob: '',
            agreement: false,
      });
      const location = useLocation();
      const navigate = useNavigate();
      const usersService = new UsersService();
      const fhirService = new FhirService();


      useEffect(() => {
            const query = new URLSearchParams(location.search);
            const uid = query.get('uid');
            console.log("validated uid in verifyEmail: " + uid)
            const verifyUser = async () => {
                  try {
                        //const user = await firebase.auth.getUser(uid);
                        //const user = firebase.auth.currentUser;
                        // await user.reload();
                        const userRef = firebase.db.ref(`users/${uid}`);
                        const snapshot = await userRef.once('value');
                        const userData = snapshot.val();
                        console.log("here0");
                        if (userData) {
                              setFormData({
                                    name: userData.name || '',
                                    dob: '',
                                    agreement: false,
                              });
                              setVerified(true);
                        } else {
                              toast.error('Email verification failed. Please try again.');
                              navigate('/login');
                        }
                  } catch (error) {
                        toast.error('Invalid verification link.');
                        navigate('/login');
                  } finally {
                        setLoading(false);
                  }
            };

            verifyUser();
      }, [firebase, location.search, navigate]);

      const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setFormData((prevData) => ({
                  ...prevData,
                  [name]: type === 'checkbox' ? checked : value,
            }));
      };

      const handleSubmit = async (e) => {
            e.preventDefault();
            const { name, dob, agreement } = formData;

            if (!name || !dob || !agreement) {
                  toast.error('Please fill out all fields and agree to the terms.');
                  return;
            }

            try {
                  const query = new URLSearchParams(location.search);
                  const uid = query.get('uid');
                  console.log("here2");
                  //const user = await firebase.auth.getUser(uid);
                  const user = firebase.auth.currentUser;
                  const userRef = firebase.db.ref(`users/${uid}`);
                  const snapshot = await userRef.once('value');
                  const userData = snapshot.val();
                  await user.updateProfile({ displayName: name });
                  console.log("here3");
                  // Store additional information like DOB in your backend or database
                  // Update Firestore or Realtime Database
                  await firebase.db.ref(`users/${uid}`).update({
                        name,
                        dob,
                        agreement,
                        verified: true,
                  });
                  console.log("Here4 Current user:", JSON.stringify(user, null, 2));

                  // Destructuring userData to exclude verified and agreement
                  //const { verified, agreement, userDataHyp } = userData;
                  console.log("here3.1");
                  // console.log("Sanitized userData:", JSON.stringify(userDataHyp, null, 2));
                  //Here we should create the hyperledger account and the fhir account. 
                  //create hyperleger
                  console.log("here4.5");
                  if (userData) {
                        // Sanitize user data
                        console.log("here4.5=6");
                        // let sanitizedUserData = Object.fromEntries(
                        //       Object.keys(userData).map(k => [k, validator.escape(userData[k])])
                        // );
                        console.log("here4.7");

                        console.log("here5");
                        // Update user data in Firebase
                        //await user.update(sanitizedUserData);
                        //console.log("here6, san: " + JSON.stringify(sanitizedUserData));
                        // Call createNewUser with the sanitized data
                        // Destructuring userData to exclude verified and agreement
                        const { mieUserID, verified, agreement, dob, ...sanitizedUserData } = userData;

                        userData.name = name;
                        userData.dob = dob;
                        userData.verified = true;
                        console.log("Here4 Current userData:", JSON.stringify(userData, null, 2));
                        // Update user data in Firebase
                        //await userRef.update(userData);
                        // Call createPeronFhir with the sanitized data
                        const fhirPersonResource = {
                              resourceType: "Person",
                              id: userData.paymentID, // Assuming paymentID is used as the id
                              identifier: [{
                                    system: "https://fhir.mieros.cloud/fhir/ids",
                                    value: userData.mieUserID // Using userID as the identifier value
                              }],
                              active: userData.verified, // Assuming 'verified' indicates if the record is active
                              name: [{
                                    //family: userData.userType, // Assuming userType is used as family name
                                    given: userData.name,
                                    displayName: userData.userID
                              }],
                              telecom: userData.phone,
                              gender: userData.gender,
                              birthDate: userData.birthDate,
                              deceasedBoolean: false, // Assuming the user is not deceased
                              photo: userData.photo,
                              communication: [{
                                    language: "en", // Assuming English language
                                    preferred: "en"
                              }]
                        };
                        console.log("here6: " + JSON.stringify(fhirPersonResource));
                        const responseFhir = await fhirService.createNewUser(fhirPersonResource);
                        console.log("here7");
                        if (responseFhir.success) {
                              toast.success('MiEROS Person created successfully!');
                        } else {
                              toast.error('Error creating MiEROS Person...');
                        }
                        // Call createNewUser with the sanitized data
                        const response = await usersService.createNewUser(sanitizedUserData);
                        console.log("here7");
                        if (response.success) {
                              toast.success('MiEROS wallet created successfully!');
                              navigate('/dashboard');
                        } else {
                              toast.error('Error creating MiEROS wallet. Please try again.');
                        }



                  } else {
                        console.log("no user data");
                  }

            } catch (error) {
                  toast.error('Error updating profile. Please try again.');
            }
      };

      if (loading) {
            return <div>Loading...</div>;
      }

      return (
            <div className="verify-email-container">
                  <CCard className="verify-email-card">
                        <CCardBody>

                              <img src={logo} alt="mIexistence" className="img-circle-login img-small" />

                              {verified ? (
                                    <CForm onSubmit={handleSubmit}>
                                          <p align="center" className="text-medium-emphasis">Verify your account</p>
                                          <CInputGroup className="mb-3">
                                                <CInputGroupText>
                                                      <CIcon icon={cilUser} />
                                                </CInputGroupText>
                                                <CFormInput
                                                      name="name"
                                                      value={formData.name}
                                                      onChange={handleChange}
                                                      type="text"
                                                      placeholder="Name"
                                                      autoComplete="name"
                                                      required
                                                />
                                          </CInputGroup>
                                          <CInputGroup className="mb-3">
                                                <CInputGroupText>
                                                      <CIcon icon={cilCalendar} />
                                                </CInputGroupText>
                                                <CFormInput
                                                      name="dob"
                                                      value={formData.dob}
                                                      onChange={handleChange}
                                                      type="date"
                                                      placeholder="Date of Birth"
                                                      autoComplete="dob"
                                                      required
                                                />
                                          </CInputGroup>
                                          <CInputGroup className="mb-1">

                                                <CFormCheck
                                                      name="agreement"
                                                      type="checkbox"
                                                      checked={formData.agreement}
                                                      onChange={handleChange}
                                                      required
                                                />
                                                <label className="ms-2">I agree to the terms and conditions</label>
                                          </CInputGroup>
                                          <CRow>
                                                <CCol xs={12}>
                                                      <CButton align="center" color="primary" className="px-4 w-100" type="submit">
                                                            Submit
                                                      </CButton>
                                                </CCol>
                                          </CRow>
                                    </CForm>
                              ) : (
                                    <div>Email not verified. Please check your email for the verification link.</div>
                              )}
                        </CCardBody>
                  </CCard>
            </div>
      );
};

export default withFirebase(VerifyEmail);
